import { Plane, Compass, Lightbulb, Moon, UtensilsCrossed, MapPin, Sparkles, Clock } from "lucide-react";

export const LEG_COLOURS = ["#d97706", "#0f766e", "#b91c1c", "#1e3a8a", "#7c3aed", "#be185d", "#0891b2", "#65a30d", "#c2410c", "#475569"];
export const CATEGORY_COLOURS = ["#0284c7", "#0d9488", "#ca8a04", "#64748b", "#7c3aed", "#be185d", "#dc2626", "#c2410c", "#65a30d", "#475569"];

export const ICON_REGISTRY = {
  plane:           { component: Plane,           label: "Plane" },
  compass:         { component: Compass,         label: "Compass" },
  lightbulb:       { component: Lightbulb,       label: "Lightbulb" },
  moon:            { component: Moon,            label: "Moon" },
  utensilsCrossed: { component: UtensilsCrossed, label: "Cutlery" },
  mapPin:          { component: MapPin,          label: "Pin" },
  sparkles:        { component: Sparkles,        label: "Sparkles" },
  clock:           { component: Clock,           label: "Clock" },
};

export const ICON_PICKER_ORDER = ["plane", "compass", "utensilsCrossed", "lightbulb", "moon", "mapPin", "sparkles", "clock"];

export const resolveIcon = (id) => ICON_REGISTRY[id]?.component || Sparkles;

export const DEFAULT_CATEGORIES = [
  { id: "transport", label: "Transport",     icon: "plane",   colour: "#0284c7", sortOrder: 0 },
  { id: "activity",  label: "Activity",      icon: "compass", colour: "#0d9488", sortOrder: 1 },
  { id: "idea",      label: "Idea",          icon: "lightbulb", colour: "#ca8a04", sortOrder: 2 },
  { id: "accom",     label: "Accommodation", icon: "moon",    colour: "#64748b", sortOrder: 3 },
];

export const STATUSES = [
  { id: "idea",    label: "Idea",     dot: "#94a3b8" },
  { id: "planned", label: "Planned",  dot: "#0ea5e9" },
  { id: "booked",  label: "Booked",   dot: "#7c3aed" },
  { id: "done",    label: "Done",     dot: "#059669" },
];

export const TIME_SLOTS = [
  { id: "morning",   label: "Morning",   range: "06–12" },
  { id: "afternoon", label: "Afternoon", range: "12–18" },
  { id: "evening",   label: "Evening",   range: "18–22" },
  { id: "night",     label: "Night",     range: "22+"   },
  { id: "anytime",   label: "Anytime",   range: ""      },
];
